<div class="container">
    <h2 mat-dialog-title>Edit Beyond Supplier</h2>

    <!-- Basic Fields Form -->
    <mat-form [formGroup]="formGroup" class="basic-fields-form">
        <div *ngFor="let field of this.form">
            <mat-form-field appearance="outline" *ngIf="field.type !== 'slide' && field.name !== 'group' && field.name !== 'status'">
                <div *ngIf="field.editable">
                    <mat-label>{{ field.title }}</mat-label>
                    <span matTextPrefix>{{ field.prefix }}&nbsp;</span>

                    <input matInput [formControlName]="field.name" [type]="field.type" [placeholder]="field.placeholder" [readonly]="!field.editable" [hidden]="!field.editable"
                        step="any" *ngIf="field.format == undefined" [value]="field.control.value">
                    <input matInput [formControlName]="field.name" [type]="field.type" [placeholder]="field.placeholder" [readonly]="!field.editable" [hidden]="!field.editable"
                        step="any" *ngIf="field.format == 'phone'" [value]="field.control.value | phone">
                </div>

                <div *ngIf="!field.editable">
                    <mat-label>{{ field.title }}</mat-label>
                    <span matTextPrefix>{{ field.prefix }}&nbsp;</span>

                    <input matInput hidden disabled [value]="field.control.value">
                </div>

                <mat-error *ngIf="field.control.invalid && (field.control.dirty|| field.control.touched)">
                    <span *ngIf="field.control.errors?.['required']">{{ field.title }} is required</span>
                    <span *ngIf="field.control.errors?.['duplicate']">Duplicate {{ field.title }}</span>
                    <span *ngIf="field.control.errors?.['pattern']">{{ field.title }} is invalid</span>
                    <span *ngIf="field.control.errors?.['email']">{{ field.title }} is an invalid email</span>
                    <span *ngIf="field.control.errors?.['maxlength'] || field.control.errors?.['minlength']">{{ field.title }} has an invalid length</span>
                </mat-error>
            </mat-form-field>

            <div class="slide-toggle" *ngIf="field.type === 'slide' && field.editable">
                <mat-slide-toggle [formControlName]="field.name">{{field.control.value ? 'Active' : 'Inactive'}}</mat-slide-toggle>
            </div>
        </div>

        <!-- Status Dropdown -->
        <div class="status-dropdown">
            <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                    <mat-option value="active">Active</mat-option>
                    <mat-option value="suspended">Suspended</mat-option>
                    <mat-option value="terminated">Terminated</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Group Dropdown -->
        <div class="group-dropdown">
            <mat-form-field appearance="outline" *ngIf="groupsLoading || availableGroups.length > 0">
                <mat-label>Group</mat-label>

                <mat-select formControlName="group">
                    <mat-option *ngFor="let group of availableGroups" [value]="group.name">
                        {{ group.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div *ngIf="!groupsLoading && availableGroups.length === 0">
                <mat-label>No Groups Available</mat-label>
            </div>
        </div>
    </mat-form>

    <!-- Permissions and Companies Sections Outside Main Form -->
    <div [formGroup]="formGroup" class="arrays-section">

        <!-- Permissions Section -->
        <div class="permissions-section">
            <div class="permissions-header">
                <h3>Permissions</h3>
            </div>
            
            <div formArrayName="permissions">
                <div *ngFor="let permission of permissions.controls; let i = index" [formGroupName]="i" class="permission-group">
                    <mat-form-field appearance="outline" class="permission-field">
                        <mat-label>Permission</mat-label>
                        <mat-select formControlName="permission" placeholder="Select Permission">
                            <mat-option *ngFor="let availablePermission of availablePermissions" [value]="availablePermission.permission">
                                {{ availablePermission.permission }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field appearance="outline" class="permission-field">
                        <mat-label>Company ID</mat-label>
                        <input matInput formControlName="companyId" type="number" placeholder="Company ID">
                    </mat-form-field>
                    
                    <button mat-icon-button color="warn" (click)="removePermission(i)" class="remove-button">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            
            <div *ngIf="permissionsLoading" class="loading-permissions">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Loading permissions...</span>
            </div>
            
            <div *ngIf="!permissionsLoading && availablePermissions.length === 0" class="no-permissions">
                <mat-icon>warning</mat-icon>
                <span>No permissions available</span>
            </div>
            
            <button mat-raised-button color="primary" (click)="addPermission()" class="add-button" [disabled]="permissionsLoading">
                <mat-icon>add</mat-icon>
                Add Permission
            </button>
        </div>

        <!-- Companies Section -->
        <div class="companies-section">
            <h3>Companies</h3>
            <div formArrayName="companies">
                <div *ngFor="let company of companies.controls; let i = index" [formGroupName]="i" class="company-group">
                    <mat-form-field appearance="outline" class="company-field">
                        <mat-label>Company Ref ID</mat-label>
                        <input matInput formControlName="companyId" type="number" placeholder="Company Reference ID">
                    </mat-form-field>
                    
                    <mat-form-field appearance="outline" class="company-field">
                        <mat-label>Company Type</mat-label>
                        <input matInput formControlName="companyType" placeholder="Company Type">
                    </mat-form-field>
                    
                    <button mat-icon-button color="warn" (click)="removeCompany(i)" class="remove-button">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            <button mat-raised-button color="primary" (click)="addCompany()" class="add-button">
                <mat-icon>add</mat-icon>
                Add Company
            </button>
        </div>
    </div>

    <div class="form-actions" mat-dialog-actions>
        <button mat-flat-button color="accent" [disabled]="this.formGroup.invalid || this.isSubmitting" (click)="save()">Save Changes</button>
        <button mat-flat-button class="cancel" (click)="cancel()">Cancel</button>
    </div>
</div>
